<template>
  <div @click="closeModalsDefault">
    <div
        v-show="getDisplayHelpText && false"
        class="help-text">
      <div
          class="closer"
          @click.stop="closeHelpText"/>
      <div class="help-text-container">
        <div class="help-text-header d-flex justify-content-between align-items-center">
          <h4> Did you know the editor now supports video?</h4>
          <div @click.stop="closeHelpText">
            <icon
                class="cursor-pointer"
                name="close-icon"/>
          </div>
        </div>
        <div class="help-text-body">
          <p>To enable it, turn on "Video Mode" in the Details toolbar or click "Enable" below.</p>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <label>
              <input
                  v-model="videoHelpChecked"
                  type="checkbox"
                  class="form-check-input">
              Don't show this message again.
            </label>

            <button
                class="btn-primary bm-primary-btn"
                @click.stop="enableVideoMode">Enable
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-panel-wrapper">
      <div
          v-if="!getDisplayAnimationPanel"
          class="main-widget-wrapper scroller h-100">
        <div class="panel-section-label">Document</div>
        <details-panel
            ref="detailsPanel"
            :product="product"
            :product-name="productName"
            :product-size="productSize"
            :is-open-detail-section="isOpenDetailSection"
            :is-product-size-ratio="isProductSizeRatio"
            :is-inch="isInch"
            :is-product-crop="isProductCrop"
            :is-gray-scale-on="isGrayScaleOn"
            :is-alignment-guide-on="isAlignmentGuideOn"
            :is-ruler-on="isRulerOn"
            :product-has-video-audio-animation="productHasVideoAudioAnimation"
            @OpenDetailSection="$emit('OpenDetailSection')"/>
        <div class="panel-section-label">Elements</div>
        <div
            v-if="isHealthCareMarketingCenter"
            :class="{ 'panel-card element-card': isFdicPanelOpen }"
            class="widget-inner py-8 px-16">
          <panel-heading
              :is-open="isFdicPanelOpen"
              :product-width="width"
              :product-height="height"
              :section="bankType == `CreditUnion`? LeftSectionPanelTypes.NCUA : LeftSectionPanelTypes.FDIC"
              :title="bankType == `CreditUnion`? `NCUA`:`FDIC`"
              left-icon="fdic"
          />
          <logo-panel
              v-if="isFdicPanelOpen"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"
              :fill-open="showShapeFillColorPanel"
              kind="fdic"
              @toggle-fill="toggleShapeFillColorPanel"/>
        </div>
        <div
            v-if="isHealthCareMarketingCenter"
            :class="{ 'panel-card element-card': isHousingPanelOpen }"
            class="widget-inner py-8 px-16">
          <panel-heading
              :is-open="isHousingPanelOpen"
              :product-width="width"
              :product-height="height"
              :section="LeftSectionPanelTypes.HOUSING"
              title="Equal Housing"
              left-icon="equal-housing"
          />
          <logo-panel
              v-if="isHousingPanelOpen"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"
              :fill-open="showShapeFillColorPanel"
              kind="housing"
              @toggle-fill="toggleShapeFillColorPanel"/>
        </div>
        <div
            :class="{ 'panel-card element-card': isTextPanelOpen }"
            class="widget-inner py-8 px-16">
          <panel-heading
              :is-open="isTextPanelOpen"
              :product-width="width"
              :product-height="height"
              :section="LeftSectionPanelTypes.TEXT"
              title="Text"
              left-icon="text"/>
          <text-panel
              v-if="isTextPanelOpen"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"/>
        </div>
        <div
            :class="{ 'panel-card element-card': isImagePanelOpen }"
            class="widget-inner py-8 px-16">
          <panel-heading
              :is-open="isImagePanelOpen"
              :section="LeftSectionPanelTypes.Image"
              title="Images"
              left-icon="image"/>
          <image-panel
              v-if="isImagePanelOpen"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"
              @crop="toggleCrop"/>
        </div>
        <div
            :class="[toggleShapePanel ? 'icon-tilt' : '', { 'panel-card element-card': isShapePanelOpen }]"
            :style="isShapePanelOpen ? null : { marginRight: '6px' }"
            class="widget-inner py-12 px-16 expand-icon"
            @click.stop="toggleShapeSection">
          <panel-heading
              :is-open="isShapePanelOpen"
              title="Shapes & Color"
              left-icon="shapes"
              right-icon="chevron"
              section="shape"/>
          <shape-panel
              v-if="isShapePanelOpen"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"
              :fill-open="showShapeFillColorPanel"
              @toggle-fill="toggleShapeFillColorPanel"/>
        </div>
        <div
            :class="{ 'panel-card element-card': showTablePanel }"
            class="widget-inner py-8 px-16">
          <panel-heading
              :is-open="showTablePanel"
              :product-width="width"
              :product-height="height"
              :section="LeftSectionPanelTypes.TABLE"
              title="Tables"
              left-icon="tableIcon"
          />
          <table-panel
              v-if="showTablePanel"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"
              :is-table-cell-editing="isTableCellEditing"
              :editing-table-id="editingTableId"
              :editing-table-sel="editingTableSel"
              :editing-table-active-cell="editingTableActiveCell"
              :table-cell-styles="tableCellStyles"
              @cell-style="emitTableCellStyle"/>
        </div>
        <div
            :class="{ 'panel-card element-card': isVideoPanelOpen }"
            class="widget-inner py-8 px-16">
          <panel-heading
              :is-open="isVideoPanelOpen"
              :section="LeftSectionPanelTypes.Video"
              :product-width="width"
              :product-height="height"
              title="Video"
              section="Video"
              left-icon="video-icon"
          />
          <video-panel
              v-if="isVideoPanelOpen"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"/>
        </div>

        <div
            :class="{ 'panel-card element-card': isAddressPanelOpen }"
            class="widget-inner py-8 px-16">
          <panel-heading
              :is-open="isAddressPanelOpen"
              :product-height="height"
              :product-width="width"
              :product-address-boxes="getProductAddressBoxes"
              :section="LeftSectionPanelTypes.ADDRESS"
              title="Address"
              left-icon="address"
          />
          <address-panel
              v-if="isAddressPanelOpen"
              ref="activePanel"
              v-bind="panelContext"
              :width="width"
              :height="height"
              :product-crop="productCrop"
              :product-address-boxes="getProductAddressBoxes"/>
        </div>
        <div
            v-if="1"
            class="widget-inner py-8 px-16">
          <panel-heading
              :section="LeftSectionPanelTypes.QRCODE"
              title="QR Code"
              left-icon="qrcode"/>
        </div>
        <audio-component
            v-if="isVideoMoodOn"
            :product="product"
        />
        <mixed-selection-panel
            v-if="areAllSelectedObjetcsMultipleTypes && isMultiPropertySelection"
            ref="activePanel"
            v-bind="panelContext"
            :width="width"
            :height="height"
            :product-crop="productCrop">
          <fill-color-section
              v-if="areAllSelectedObjectsHousingAndFDIC && isMultiPropertySelection"
              :open="showShapeFillColorPanel"
              title="Fill color"
              @toggle="toggleShapeFillColorPanel">
            <color-picker
                :color="getColorLabelShape"
                :type="getObjectType"
                :key="'color-picker-'+((activeObjectForLeftPanel && activeObjectForLeftPanel.Id) || 'none')+'-'+((activeObjectForLeftPanel && activeObjectForLeftPanel.isGradient) || false)+'-'+getSelectedPointOfGradient"
                :active-object="activeObjectForLeftPanel"
                :selected-objects-list="getSelectedObjectsList"
                :content-list="contentList"
                display-style="inline"
                variant="panel"
                color-type="fill"
                @updateSelectedPointOfGradient="updateSelectedPointOfGradient"
                @updateSelectedPointPosition="updateSelectedPointPosition"
                @changeMode="handleModeChange"
                @updateSelectedGradientAngle="updateSelectedGradientAngle"
            />
          </fill-color-section>
        </mixed-selection-panel>
      </div>
      <div
          v-else
          class="main-widget-wrapper scroller h-100">
        <animation-panel
            :product="product"
            :active-page="activePage"
            :active-object="activeObjectForLeftPanel"
            :selected-objects-list="getSelectedObjectsList"/>
      </div>
    </div>
    <bg-remover
        v-if="$store.getters.getIsBgRemoverOpen"
        :active-object="activeObject"/>
  </div>
</template>
<script>

import _ from 'lodash';
import PanelHeading from '@/components/PanelHeading/PanelHeading';
import EventBus from '@/EventBus';
import LeftSectionPanelTypes from '@/mixins/LeftSectionPanelTypes';
import ColorPicker from '@/components/ColorPicker/ColorPicker';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes'; // TDOD: Change to @/
import AudioComponent from '@/components/Audio/AudioComponent';
import ImageObject from '@/components/DesignObjects/ImageObject';
import { getMaxZIndex } from '@/components/Helper';
import { uuid } from 'vue-uuid';
import ElementAnimationMixin from '@/mixins/ElementAnimation';
import AnimationPanel from '@/components/AnimationPanel/AnimationPanel';
import BgRemoverModal from '@/components/BgRemover/BgRemoverModal';
import {
  findObjectById,
  findFirstSelectedObject,
  getNextTableName,
} from '@/components/Canvas/utils/groupHelpers';
import panelContext from '@/components/LeftSection/mixins/panelContext';
import objectEffects from '@/components/LeftSection/mixins/objectEffects';
import gradientFill from '@/components/LeftSection/mixins/gradientFill';
import DetailsPanel from '@/components/LeftSection/panels/DetailsPanel';
import MixedSelectionPanel from '@/components/LeftSection/panels/MixedSelectionPanel';
import TextPanel from '@/components/LeftSection/panels/TextPanel';
import TablePanel from '@/components/LeftSection/panels/TablePanel';
import ImagePanel from '@/components/LeftSection/panels/ImagePanel';
import VideoPanel from '@/components/LeftSection/panels/VideoPanel';
import AddressPanel from '@/components/LeftSection/panels/AddressPanel';
import ShapePanel from '@/components/LeftSection/panels/ShapePanel';
import LogoPanel from '@/components/LeftSection/panels/LogoPanel';
import FillColorSection from '@/components/LeftSection/ui/FillColorSection';
import TableObject from '@/components/DesignObjects/TableObject';
export default {
  name:       'LeftSection',
  components: {
    'panel-heading':         PanelHeading,
    'color-picker':          ColorPicker,
    'animation-panel':       AnimationPanel,
    'audio-component':       AudioComponent,
    'bg-remover':            BgRemoverModal,
    'details-panel':         DetailsPanel,
    'mixed-selection-panel': MixedSelectionPanel,
    'text-panel':            TextPanel,
    'table-panel':           TablePanel,
    'image-panel':           ImagePanel,
    'video-panel':           VideoPanel,
    'address-panel':         AddressPanel,
    'shape-panel':           ShapePanel,
    'logo-panel':            LogoPanel,
    'fill-color-section':    FillColorSection,
  },
  mixins: [LeftSectionPanelTypes.Mixin, ElementAnimationMixin, panelContext, objectEffects, gradientFill],
  // product, activePage, activeObject, contentList, bankType, selectedObjectsList come from the panelContext mixin
  props:  {
    productCrop:         Object,
    width:               Number,
    height:              Number,
    ProductAddressBoxes: Array,
    isProductCrop:       Object,
    productSize:         Object,
    isAlignmentGuideOn:  { type: Boolean, default: true },
    isGrayScaleOn:       Boolean,
    checkModalOpen:      Boolean,
    isRulerOn:           Boolean,
    isOpenDetailSection: Boolean,
    isProductSizeRatio:  Boolean,
    productName:         String,
    isInch:              Boolean,

    productHasVideoAudioAnimation: {
      type:    Boolean,
      default: false,
    },
  },

  data() {
    return {
      toggleShapePanel:        false,
      toggleTablePanel:        false,
      showShapeFillColorPanel: true,
      lastFillPanelObjectId:   null,
      videoHelpChecked:        false,
      tableCellStyles:         {
        color:      '#1f1f1f',
        fontFamily: 'Arial',
        fontSize:   13,
        lineHeight: 1.4,
        bold:       false,
        italic:     false,
        underline:  false,
        align:      'center',
        vAlign:     'middle',
      },
      isTableCellEditing:     false,
      editingTableId:         null,
      editingTableSel:        null,
      editingTableActiveCell: null,
    };
  },


  computed: {
    // Shared props handed to every panel: <x-panel v-bind="panelContext"/>
    panelContext() {
      return {
        product:             this.product,
        activePage:          this.activePage,
        activeObject:        this.activeObject,
        contentList:         this.contentList,
        bankType:            this.bankType,
        selectedObjectsList: this.selectedObjectsList,
      };
    },
    isTextPanelOpen() {
      return this.getOpenPanel == LeftSectionPanelTypes.TEXT || (this.areAllSelectedObjetcsText && this.isMultiPropertySelection);
    },
    isImagePanelOpen() {
      return this.getOpenPanel == LeftSectionPanelTypes.Image || (this.areAllSelectedObjetcsImage && this.isMultiPropertySelection);
    },
    isVideoPanelOpen() {
      return this.getOpenPanel == LeftSectionPanelTypes.Video || (this.areAllSelectedObjetcsVideo && this.isMultiPropertySelection);
    },
    isFdicPanelOpen() {
      return this.getOpenPanel == LeftSectionPanelTypes.FDIC || (this.areAllSelectedObjetcsFDIC && this.isMultiPropertySelection);
    },
    isHousingPanelOpen() {
      return this.getOpenPanel == LeftSectionPanelTypes.HOUSING || (this.areAllSelectedObjetcsHousing && this.isMultiPropertySelection);
    },
    isShapePanelOpen() {
      return this.showShapePanel || (this.areAllSelectedObjetcsShape && this.isMultiPropertySelection);
    },
    isAddressPanelOpen() {
      return this.getOpenPanel == LeftSectionPanelTypes.ADDRESS || (this.areAllSelectedObjetcsWhiteBoxLogo && this.isMultiPropertySelection);
    },
    showTablePanel() {
      if (this.isMultiPropertySelection) {
        return false;
      }
      if (this.isTableCellEditing) {
        return true;
      }
      return this.selectedObjectsList.length < 2
          && (this.getOpenPanel === this.LeftSectionPanelTypes.TABLE || this.toggleTablePanel);
    },
    isVideoMoodOn() {
      return this.product && this.$store.getters['activeProduct/getIsVideoMoodOn'];
    },
    getDisplayAnimationPanel() {
      let display = true;
      if (this.activeObject) {
        display = true;
      }
      return this.$store.getters['activeProduct/getDisplayAnimationPanel'] && display;
    },
    isHealthCareMarketingCenter() {
      return this.$store.getters.getBMCInstance !== 'healthcaremarketingcenter';
    },
    getProductAddressBoxes() {
      return this.ProductAddressBoxes;
    },

    getOpenPanel() {
      this.toggleShapePanel = false;
      if (this.isMultiPropertySelection) {
        return this.LeftSectionPanelTypes.NONE;
      }
      const selectedCount = this.getSelectedObjectsList.length;
      if (!this.activeObjectForLeftPanel || selectedCount > 1) {
        return this.LeftSectionPanelTypes.NONE;
      }
      if (this.activeObjectForLeftPanel.type == 'text') {
        return this.LeftSectionPanelTypes.TEXT;
      }
      if (this.activeObjectForLeftPanel.ImageType == 'Image') {
        return this.LeftSectionPanelTypes.Image;
      }
      if (this.activeObjectForLeftPanel.ImageType == 'FDICText' || this.activeObjectForLeftPanel.ImageType == 'FDICTextWhite') {
        return this.LeftSectionPanelTypes.FDIC;
      } // FDIC use type FDICText for black color and other for white color
      if (this.activeObjectForLeftPanel.ImageType == 'WhiteboxLogo' || this.activeObjectForLeftPanel.ImageType == 'IndependentWhitebox') {
        return this.LeftSectionPanelTypes.ADDRESS;
      }
      if (this.activeObjectForLeftPanel.ImageType == 'FDICLogo' || this.activeObjectForLeftPanel.ImageType == 'FDICLogoWhite') {
        return this.LeftSectionPanelTypes.HOUSING;
      }
      if (this.activeObjectForLeftPanel.ImageType == 'SVGImage') {
        return this.LeftSectionPanelTypes.SVGIMAGE;
      }
      if (this.activeObjectForLeftPanel.type == 'shape') {
        return this.LeftSectionPanelTypes.SHAPES;
      }
      if (this.activeObjectForLeftPanel.type == 'video') {
        return this.LeftSectionPanelTypes.Video;
      }
      if (this.activeObjectForLeftPanel.type === 'table') {
        return this.LeftSectionPanelTypes.TABLE;
      }
      return this.LeftSectionPanelTypes.NONE;
    },
    getDisplayHelpText() {
      return localStorage.getItem('displayHelpText') != 'false' && !this.isVideoMoodOn && this.getDisplayHelpTextStore;
    },
    getDisplayHelpTextStore() {
      return this.$store.getters.getDisplayHelpText;
    },
    showShapePanel() {
      return this.getSelectedObjectsList.length < 2 && (this.getOpenPanel == LeftSectionPanelTypes.SHAPES || this.getOpenPanel == LeftSectionPanelTypes.SVGIMAGE || this.toggleShapePanel);
    },
  },
  watch: {
    product(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    },
    'activeObjectForLeftPanel.Id': function onLeftPanelObjectChange(newId) {
      const object = this.activeObjectForLeftPanel;
      if (!newId || newId === this.lastFillPanelObjectId) { return; }
      this.lastFillPanelObjectId = newId;
      if (object && (object.type == 'shape' || object.ImageType == 'SVGImage')) {
        this.showShapeFillColorPanel = true;
      }
    },
  },
  async mounted() {
    window.onresize = this.setScalePopUP;
    EventBus.$on('modalsCloser', this.onmodalClose);
    EventBus.$on(ApplicationEventTypes.ModalEvents.TOGGLE_CROP_IMAGE_MODAL, this.toggleCrop);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.RESET, this.resetLeftPanelStates);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_SIZE, this.changeFontSize);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_LINE_HEIGHT, this.changeCharacterSpacing);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_COLOR, this.changeFontColor);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_SHADOW_COLOR, this.updateTextShadowColor);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_OUTLINE_COLOR, this.updateTextOutlineColor);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_SHADOW_COLOR, this.changeShapeShadowColor);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_FAMILY, this.changeFontFamily);
    EventBus.$on('closeLeftPanelPopovers', this.closeLeftPanelPopovers);
    EventBus.$on(ApplicationEventTypes.ImageObjectEvents.SELECTED_IMAGE_FOR_LEFT_PANEL, this.addingAlternativeImage);
    EventBus.$on('AddSvgShape', this.onAddingShapeSVG);
    EventBus.$on('tableCellSelectionChanged', this.onTableCellSelectionChanged);
    EventBus.$on('tableCellSelectionCleared', this.onTableCellSelectionCleared);
    EventBus.$on('addTableFromPanel', this.addTableObject);
    EventBus.$on('addBgRemoverImage', this.addBgRemoverImage);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.UPDATE_IMAGE_BORDER_COLOR, this.onImageBorderColorChanged);
    EventBus.$on(ApplicationEventTypes.TextObjectEvents.TEXT_SELECTION_UPDATED, this.onTextSelectionUpdatedForEffects);
    if (localStorage.getItem('displayHelpText') == null) {
      console.log('displayHelpText');
      localStorage.setItem('displayHelpText', true);
    }
  },
  beforeDestroy() {
    EventBus.$off('modalsCloser', this.onmodalClose);
    EventBus.$off(ApplicationEventTypes.ModalEvents.TOGGLE_CROP_IMAGE_MODAL, this.toggleCrop);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.RESET, this.resetLeftPanelStates);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_SIZE, this.changeFontSize);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_SHADOW_COLOR, this.updateTextShadowColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_OUTLINE_COLOR, this.updateTextOutlineColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_SHADOW_COLOR, this.changeShapeShadowColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_LINE_HEIGHT, this.changeCharacterSpacing);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_COLOR, this.changeFontColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_FAMILY, this.changeFontFamily);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.SELECTED_IMAGE_FOR_LEFT_PANEL, this.addingAlternativeImage);
    EventBus.$off('AddSvgShape', this.onAddingShapeSVG);
    EventBus.$off('closeLeftPanelPopovers', this.closeLeftPanelPopovers);
    EventBus.$off('addBgRemoverImage', this.addBgRemoverImage);
    EventBus.$off('tableCellSelectionChanged', this.onTableCellSelectionChanged);
    EventBus.$off('tableCellSelectionCleared', this.onTableCellSelectionCleared);
    EventBus.$off('addTableFromPanel', this.addTableObject);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.UPDATE_IMAGE_BORDER_COLOR, this.onImageBorderColorChanged);
    EventBus.$off(ApplicationEventTypes.TextObjectEvents.TEXT_SELECTION_UPDATED, this.onTextSelectionUpdatedForEffects);
  },
  methods: {
    onTableCellSelectionChanged(payload) {
      if (!payload || !payload.styles) { return; }
      const nextId          = payload.tableId || null;
      const nextActive      = payload.activeCell ? { ...payload.activeCell } : null;
      const identityChanged = nextId !== this.editingTableId
          || !this.editingTableActiveCell
          || !nextActive
          || this.editingTableActiveCell.r !== nextActive.r
          || this.editingTableActiveCell.c !== nextActive.c;

      this.isTableCellEditing     = true;
      this.editingTableId         = nextId;
      this.editingTableSel        = payload.sel ? { ...payload.sel } : null;
      this.editingTableActiveCell = nextActive;
      this.tableCellStyles        = { ...payload.styles };
      this.toggleTablePanel       = true;
      // Only close color picker when switching cells/tables — not on style sync during drag
      if (identityChanged) {
        this.$store.commit('setIsOpen', false);
      }
    },
    onTableCellSelectionCleared() {
      this.callPanel('onTableCellSelectionCleared');
      this.isTableCellEditing     = false;
      this.editingTableId         = null;
      this.editingTableSel        = null;
      this.editingTableActiveCell = null;
      this.toggleTablePanel       = false;
    },

    isTableStyleTarget() {
      return !!(this.isTableCellEditing && this.editingTableId);
    },

    ensureTableEditingContext() {
      this.isTableCellEditing = true;
      if (!this.editingTableId && this.activeObjectForLeftPanel
          && this.activeObjectForLeftPanel.type === 'table') {
        this.editingTableId = this.activeObjectForLeftPanel.Id;
      }
    },

    emitTableCellStyle(patch) {
      const tableId = this.editingTableId
          || (this.activeObjectForLeftPanel
              && this.activeObjectForLeftPanel.type === 'table'
              && this.activeObjectForLeftPanel.Id);

      if (!tableId) { return; }

      this.tableCellStyles = { ...this.tableCellStyles, ...patch };
      EventBus.$emit('updateTableCellStyles', {
        tableId,
        patch,
        sel:        this.editingTableSel,
        activeCell: this.editingTableActiveCell,
      });
    },
    // The Opacity / Adjust popovers moved into ImagePanel / VideoPanel (mediaTools mixin), so this only forwards (R5).
    closeLeftPanelPopovers() {
      this.callPanel('closeLeftPanelPopovers');
    },
    // UPDATE_IMAGE_BORDER_COLOR: update the open Image / Address panel's swatch (R5).
    onImageBorderColorChanged(color) {
      this.callPanel('updateImageBorderColor', color);
    },
    addBgRemoverImage(data) {
      EventBus.$emit('pauseVideoOnOutsideClick');
      const selectedObject       = findFirstSelectedObject(this.contentList);
      selectedObject.HighResPath = data.DefaultImageUrl;
      Object.assign(selectedObject, data);
      Object.assign(selectedObject.AlternativeImageUrlsResVersion[0], data);

      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
    },
    toggleShapeFillColorPanel() {
      this.showShapeFillColorPanel = !this.showShapeFillColorPanel;
    },
    toggleShapeSection() {
      if (this.activeObject && !this.areAllSelectedObjetcsShape) {
        this.activeObject = null;
      }
      this.$nextTick(() => {
        this.toggleShapePanel = !this.toggleShapePanel;
      });
    },
    addingAlternativeImage(data) {
      EventBus.$emit('pauseVideoOnOutsideClick');

      this.activeObjectForLeftPanel.AlternativeImageUrlsResVersion.push(data);

      const currentUploadFile = this.$store.getters['activeProduct/getCurrentUploadFile'] + 1;
      this.$store.commit('activeProduct/updateCurrentUploadFile', currentUploadFile);
      const totalUploFiles = this.$store.getters['activeProduct/getTotalUploadFiles'];
      if (totalUploFiles === currentUploadFile) {
        EventBus.$emit('showHideLoader', false);
        this.$store.commit('activeProduct/updateTotalUploadFiles', 0);
        this.$store.commit('activeProduct/updateCurrentUploadFile', 0);
      }
    },
    onAddingShapeSVG({
                       content, name, color, width, height, ImageType,
                     }) {
      EventBus.$emit('pauseVideoOnOutsideClick');
      console.log('ImageObject');
      const { data }    = new ImageObject();
      data.PdfSortOrder = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
      data.isSelected   = false;
      data.Alpha        = 100;
      data.DefaultColor = color;
      data.Width        = width;
      data.Height       = height;
      data.X            = ((this.width / 2) - width / 2);
      data.Y            = ((this.height / 2) - height / 2);
      data.ImageType    = ImageType || 'SVGImage';
      data.Name         = name;
      data.Id           = uuid.v1();

      // QR / raw SVG shapes often ship without a CSS transform. Seed one so later
      // group/child scale can update content instead of only Width.
      let svgContent = content || '';
      if (svgContent && !/transform:\s*scale\(/i.test(svgContent)) {
        if (/<svg\b[^>]*\sstyle="/i.test(svgContent)) {
          svgContent = svgContent.replace(
              /(<svg\b[^>]*\sstyle=")([^"]*)(")/i,
              (match, prefix, styleVal, suffix) => `${prefix}${styleVal}; transform-origin: left top; transform: scale(1, 1)${suffix}`,
          );
        } else {
          svgContent = svgContent.replace(
              /<svg\b/i,
              '<svg style="transform-origin: left top; transform: scale(1, 1)"',
          );
        }
      }
      data.SvgProperty.content      = svgContent;
      data.SvgProperty.DefaultColor = color || data.SvgProperty.DefaultColor;
      data.SvgProperty.svgScaleX    = 1;
      data.SvgProperty.svgScaleY    = 1;
      data.SvgProperty.style        = 'scale(1, 1)';

      EventBus.$emit('onObjectAdding', _.cloneDeep(data));
    },
    addTableObject(rows = 4, cols = 3) {
      EventBus.$emit('pauseVideoOnOutsideClick');

      const { data } = new TableObject(rows, cols);

      data.X            = Math.abs((this.width / 2) - data.Width / 2);
      data.Y            = Math.abs((this.height / 2) - data.Height / 2);
      data.Id           = uuid.v1();
      data.PdfSortOrder = data.SortOrder =          getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
      data.isSelected   = false;
      data.Name         = getNextTableName(this.contentList);
      EventBus.$emit('onObjectAdding', _.cloneDeep(data));
    },
    resetLeftPanelStates() {
    },
    closeModalsDefault(e) {
      try {
        EventBus.$emit('pauseVideoOnOutsideClick');
        this.callPanel('closeLeftPanelPopovers');
        // The Opacity / Adjust / Corners popovers and their refs live in ImagePanel / VideoPanel (R6).
        this.callPanel('closeModalsDefault', e);
      } catch (ex) {
        console.log('Error in closing Modal', ex);
      }
    },

    // EventBus 'modalsCloser' stays subscribed here (R5); the logic lives in DetailsPanel.
    onmodalClose(payload) {
      const panel = this.$refs.detailsPanel;
      if (panel) {
        panel.onmodalClose(payload);
      }
    },
    // Shared font events (SizeAdjustButton, FontFamilySelector, ColorSelector, ColorPicker):
    // table cells are styled here (the cell state lives in LeftSection), text goes to TextPanel (R5).
    changeFontSize(font, buttonType = '') { // buttonType is for increment or decrement buttons
      if (this.isTableStyleTarget()) {
        this.ensureTableEditingContext();
        this.emitTableCellStyle({ fontSize: Math.round(Number(font)) || 13 });
        return;
      }
      this.callPanel('changeFontSize', font, buttonType);
    },
    changeFontFamily(font) {
      if (this.isTableStyleTarget()) {
        this.ensureTableEditingContext();
        this.emitTableCellStyle({ fontFamily: font });
        return;
      }
      this.callPanel('changeFontFamily', font);
    },
    changeFontColor(rgb) {
      if (this.isTableStyleTarget()) {
        this.ensureTableEditingContext();
        this.emitTableCellStyle({ color: rgb });
        return;
      }
      this.callPanel('changeFontColor', rgb);
    },
    changeCharacterSpacing(lineSpace) {
      if (this.isTableStyleTarget()) {
        this.ensureTableEditingContext();
        this.emitTableCellStyle({ lineHeight: Number(lineSpace) || 1.4 });
        return;
      }
      this.callPanel('changeCharacterSpacing', lineSpace);
    },
    onTextSelectionUpdatedForEffects() {
      this.callPanel('onTextSelectionUpdatedForEffects');
    },
    // Forward an EventBus handler to the open element panel (R5).
    callPanel(method, ...args) {
      const panel = this.$refs.activePanel;
      if (panel && typeof panel[method] === 'function') {
        return panel[method](...args);
      }
      return undefined;
    },

    toggleCrop() {
      if (this.activeObjectForLeftPanel.stencilDefaultPositionTop === null || this.activeObjectForLeftPanel.stencilDefaultPositionLeft === null) {
        const imageObject = document.getElementById(this.activeObjectForLeftPanel.Id).firstElementChild;
        const imgWidth    = imageObject.naturalWidth;
        const imgHeight   = imageObject.naturalHeight;
        const stencilLeft = parseInt((parseInt(imgWidth) - parseInt(this.activeObjectForLeftPanel.Width)) / 2);
        const stencilTop  = parseInt((parseInt(imgHeight) - parseInt(this.activeObjectForLeftPanel.Height)) / 2);
        if (this.activeObjectForLeftPanel.stencilDefaultPositionTop === null) {
          this.activeObjectForLeftPanel.stencilDefaultPositionTop = stencilTop;
        }
        if (this.activeObjectForLeftPanel.stencilDefaultPositionLeft === null) {
          this.activeObjectForLeftPanel.stencilDefaultPositionLeft = stencilLeft;
        }
      }
      const data = {
        isEnable: !this.$store.getters.getCrop.isEnable,
        object:   this.activeObjectForLeftPanel,
      };
      this.$store.commit('updateCrop', data);
    },

    enableVideoMode() {
      console.log('asd');
      this.closeHelpText();
      if (this.videoHelpChecked) {
        localStorage.setItem('displayHelpText', false);
      }
      this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
      EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
    },

    closeHelpText() {
      this.$store.commit('setDisplayHelpText', false);
    },

    changeShapeShadowColor(color, Id) {
      if (this.contentList && this.contentList.length > 0) {
        const selectedObject = findObjectById(this.contentList, Id);
        if (!selectedObject) {
          return;
        }
        if (!selectedObject.shadow) {
          this.$set(selectedObject, 'shadow', { color });
        } else {
          selectedObject.shadow.color = color;
        }
        // The Image / Address / Shape / Logo panels keep the effect swatch colour (imageEffects), so forward (R5).
        this.callPanel('applyShadowColorState', color, Id);

        if (selectedObject.type == 'image' && selectedObject.ImageType != 'SVGImage' && selectedObject.ImageType.indexOf('FDICText') === -1 && selectedObject.ImageType.indexOf('FDICLogo') === -1) {
          this.changeImageShadowColorInDom(color, Id);
        } else {
          const elem        = document.querySelector(`.canvas-main-html-container [id='${selectedObject.Id}']`);
          elem.style.filter = `drop-shadow(${selectedObject.shadow.shadowOffsetX}px ${selectedObject.shadow.shadowOffsetY}px ${selectedObject.shadow.blur * 40}px ${color})`;
        }
      }
    },

    changeImageShadowColorInDom(color, Id) {
      const elem           = document.querySelector(`.canvas-main-html-container [id='${Id}']`);
      const selectedObject = findObjectById(this.contentList, Id);
      if (!selectedObject) {
        return;
      } // Ensure selectedObject exists
      const shadow = (selectedObject && selectedObject.shadow) ? selectedObject.shadow : {
        color:         '#846C63',
        X:             0,
        Y:             0,
        blur:          0,
        angle:         0,
        distance:      0.04, // imageEffects' default objectShadowDistance (not used for the filter below)
        shadowOffsetX: 0,
        shadowOffsetY: 0,
      };
      if (elem) {
        // Get computed filter value
        let currentFilter = getComputedStyle(elem).filter;
        console.log('currentFilter ', currentFilter);

        // Normalize empty/none filter
        if (!currentFilter || currentFilter === 'none') {
          currentFilter = '';
        }

        // Remove existing drop-shadow if present
        const filterWithoutDropShadow = currentFilter
            .split(/\s+(?![^(]*\))/) // split by spaces not inside functions
            .filter(f => !f.startsWith('drop-shadow'))
            .join(' ');

        const newShadowValue = `drop-shadow(${shadow.shadowOffsetX}px ${shadow.shadowOffsetY}px ${shadow.blur * 40}px ${color})`;

        const updatedFilter = filterWithoutDropShadow ? `${filterWithoutDropShadow} ${newShadowValue}` : newShadowValue;

        // Apply the updated filter
        elem.style.filter = updatedFilter;
      }
    },
  },
};

</script>
<style lang="scss">
@import './styles/lp-global';
</style>
<style lang="scss" scoped>
@import './styles/lp-tokens';

.help-text {
  background: red;
  position: fixed;
  z-index: 999;
  left: 360px;
  top: 45px;
  width: 400px;
  background: white;
  border-radius: 3px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);

  .help-text-container {
    position: relative;
    z-index: 3;

    &::before {
      position: absolute;
      content: " ";
      top: 15px;
      left: -10px;
      height: 20px;
      width: 20px;
      background: white;
      transform: rotate(45deg);
      z-index: -1;
      box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    }

    .help-text-header {
      background-color: #ffffff;
      border-bottom: 1px solid #EDEDED;
      padding: 15px 20px;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      overflow: hidden;

      h4 {
        margin: 0;
      }
    }

    .help-text-body {
      padding: 15px 20px;
      background: white;
      border-bottom-right-radius: 3px;
      border-bottom-left-radius: 3px;
    }
  }

  p {
    font-size: 14px;
  }

  .closer {
    position: absolute;
    width: 200vw;
    height: 200vh;
    left: 0;
    z-index: 2;
    top: 0;
    transform: translate(-50%, -50%);
  }

}

.emoji-picker-popup {
  position: fixed;
  top: 335px;
  left: 214px;
  z-index: 9999;
  --emoji-font-family: "Twemoji Mozilla", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", sans-serif;
}
</style>
